export default "__VITE_ASSET__DX9QJV5___ 100w";